import { useLayoutEffect, useRef } from 'react';

/* Le champ suit la hauteur du texte, puis défile au-delà du plafond : sans ce
   plafond, un long brouillon pousse les messages hors de l'écran. */
export function useAutoGrowTextarea(value: string, maxHeightPx: number) {
  const ref = useRef<HTMLTextAreaElement>(null);
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = 'auto';
    el.style.height = `${Math.min(el.scrollHeight, maxHeightPx)}px`;
    el.style.overflowY = el.scrollHeight > maxHeightPx ? 'auto' : 'hidden';
  }, [value, maxHeightPx]);
  return ref;
}
